module.exports = __webpack_public_path__ + "static/b2c_v2-82d8257ac795992675914b9a6b7c545d.svg";